import angular from 'angular';
import helloPackEditor from './helloPackEditor';
import components from './components';
import './style.scss';

export default angular
  .module('helloPack.scenes.helloPackEditor', [components])
  .component('helloPackEditor', helloPackEditor).name;
